<template>
  <div class="toast-container">
    <div class="toast">
      <div
        v-if="toastInfo.toastType === ToastType.Error"
        class="toast-message"
      >
        <div class="toast-warning">
          <p class="toast-error-text">先用后付使用失败，正在为您跳转收银台</p>
        </div>
      </div>
      <div
        v-if="toastInfo.toastType === ToastType.Text"
        class="toast-message"
      >
        {{ toastInfo.toastText }}
      </div>
      <div
        v-if="toastInfo.toastType === ToastType.PayLogo"
        :class="[
          'toast-message',
          'pay-logo-container',
          toastInfo.payType === PayType.WeiXin ? 'weixin-logo-style' : '',
        ]"
      >
        <img
          v-if="toastInfo.payType === PayType.WeiXin"
          class="pay-logo"
          src="https://p0.meituan.net/paydefer/weixin-icon.png"
          alt=""
        />
        <img
          v-else
          class="pay-logo"
          src="../../assets/pay-delay-icon.png"
          alt=""
        />
        <p class="pay-logo-text">{{ toastInfo.toastText }}</p>
        <p
          v-if="toastInfo.toastSubText"
          class="pay-logo-subText"
        >
          {{ toastInfo.toastSubText }}
        </p>
      </div>
      <div
        v-if="toastInfo.toastType === ToastType.Success"
        class="toast-message toast-box-success"
      >
        <i class="icon-success-outline"></i>
        下单成功
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { ToastType, PayType } from '@/common';

export default Vue.extend({
  name: 'App',
  data() {
    return {
      ToastType,
      PayType,
    };
  },
  computed: {
    toastInfo() {
      return this.$store.state.paydelaycashier.toastData;
    },
  },
});
</script>

<style lang="less" scoped>
.toast-container {
  height: 100%;
  position: relative;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  .pay-logo-container {
    padding: 32px;
    line-height: 40px;
    width: 254px;
    height: 236px;
    background: rgba(26, 26, 26, 0.9);
    border-radius: 36px;
    color: #ffffff;
    .pay-logo {
      width: 66px;
      height: 66px;
    }
    .pay-logo-text {
      font-size: 32px;
      line-height: 44px;
      font-weight: 500;
      margin-bottom: 8px;
    }
    .pay-logo-subText {
      margin: 0;
      font-size: 28px;
      line-height: 40px;
    }
  }
}
</style>
